<div class="page-sale-config">
    <mat-form-field appearance="fill" class="custom-mat-select" *ngIf="typeTicketsSession && sessions?.length > 1">
        <mat-select placeholder="Selecciona una sesión" [value]="selectedSession" (valueChange)="changeSession($event)">
            <mat-option *ngFor="let session of sessions; let i = index" [value]="i">
                {{session.start_date | date:'dd/MM/yyyy HH:mm':'+0000'}}
            </mat-option>
        </mat-select>
        <mat-select-trigger matSuffix style="margin-right: 10px;">
            <i class="fal fa-angle-down pointer-in"></i>
        </mat-select-trigger>
    </mat-form-field>

    <div class="d-flex align-items-center title-edit">
        <p class="m-0 title-tab">Editar configuración de venta</p>
    </div>
    <div class="config-tickets">
        <form [formGroup]="formConfig" class="form-entrada">
            <!-- Entradas nominativas: decide cómo se emite y cómo se valida la entrada,
                 así que abre la configuración de venta en vez de quedar al final entre
                 los ajustes menores. Solo durante el alta: una vez creado el evento no
                 se puede cambiar (mismo criterio que el tipo de evento), porque a esas
                 alturas puede haber pedidos hechos con el modelo contrario y cambiarlo
                 dejaría entradas incoherentes con el evento. -->
            <div class="nominative-card" [class.active]="isNominative" *ngIf="!embedded">
                <div class="nominative-head">
                    <i class="fa-light fa-id-card nominative-icon"></i>
                    <div class="nominative-titles">
                        <p class="nominative-title">Entradas nominativas</p>
                        <p class="nominative-subtitle">
                            Cada entrada se emite a nombre de su titular y en el acceso se le pide el documento
                            identificativo.
                        </p>
                    </div>
                    <mat-slide-toggle class="toggle-pink" formControlName="nominative_tickets"></mat-slide-toggle>
                </div>
                <div class="nominative-detail" *ngIf="isNominative">
                    <i class="fa-light fa-circle-info"></i>
                    <span>
                        En la venta por web la entrada se emitirá con el nombre y el documento identificativo del
                        comprador, y en el acceso se le pedirá ese documento; cada usuario podrá comprar solo 1 entrada
                        por sesión. En taquilla el evento se vende con normalidad, como una entrada no nominativa.
                    </span>
                </div>
            </div>
            <!-- En edición la tarjeta con el interruptor sobra: el dato ya se ve en el
                 badge de la cabecera y aquí no hay nada que decidir. Queda solo la línea
                 que explica por qué no se puede cambiar. -->
            <p class="nominative-note" *ngIf="embedded">
                <i class="fa-light fa-id-card"></i>
                <span>
                    Este evento vende entradas <b>{{ isNominative ? 'nominativas' : 'no nominativas' }}</b>. No se puede
                    cambiar una vez creado el evento: puede haber pedidos hechos con el modelo actual.
                </span>
            </p>
            <div class="info-default">
                <p class="m-0">
                    <i class="fa-light fa-circle-info icon-primary" style="margin-right: 8px;"></i>
                    Fechas de inicio y fin de venta de entradas, en caso de no indicarlas se pondrán a la venta cuando
                    se publique el evento y se terminará una hora antes de cada sesión.
                </p>
            </div>
            <!-- Fecha de venta de entradas -->
            <div class="padding-inputs">
                <div #startDateField>
                    <p class="title-dates-inputs">Fecha inicio de venta de entradas</p>
                    <div class="section-input">
                        <!-- Fecha inicio venta -->
                        <div class="d-flex align-items-center justify-content-between input-border">
                            <div class="select-style calendar-date pointer-in"
                                [class.active]="typeDatepicker == 'start'" (click)="openDatePicker('start')">
                                <i class="fa-light fa-calendar"></i>
                                <input placeholder="Inicio de venta" class="input-date pointer-in" readonly
                                    [(ngModel)]="startStringDate" [ngModelOptions]="{standalone: true}">
                                <i class="icon-down fa-light fa-chevron-down"></i>
                            </div>
                        </div>

                        <!-- Hora inicio venta -->
                        <div class="d-flex align-items-center justify-content-center inputs-hours"
                            [class.error-input]="hourInit > 23 || hourInit < 0 || minuteInit < 0 || minuteInit > 59 || minuteInit?.length > 2">
                            <div class="input-hour">
                                <input placeholder="20" type="text" maxlength="2" pattern="[0-9]*"
                                    (blur)="validateHourInput($event, 'hourInit')"
                                    (keypress)="onlyNumbers($event)"
                                    [(ngModel)]="hourInitStr"
                                    [ngModelOptions]="{standalone: true}" />
                            </div>
                            <span class="points">:</span>
                            <div class="input-hour">
                                <input placeholder="00" type="text" maxlength="2" pattern="[0-9]*"
                                    (blur)="validateMinuteInput($event, 'minuteInit')"
                                    (keypress)="onlyNumbers($event)"
                                    [(ngModel)]="minuteInitStr"
                                    [ngModelOptions]="{standalone: true}" />
                            </div>
                        </div>
                    </div>
                    <div class="calendar-option" *ngIf="typeDatepicker == 'start'">
                        <app-calendar-event-dates [selectedDate]="startDate" (saveDate)="saveDate($event)"
                            [minDate]="minDate"></app-calendar-event-dates>
                    </div>
                </div>
                <div #endDateField>
                    <p class="title-dates-inputs">Fecha fin de venta de entradas</p>
                    <div class="section-input">
                        <!-- Fecha fin venta -->
                        <div class="d-flex align-items-center justify-content-between input-border">
                            <div class="select-style calendar-date pointer-in" [class.active]="typeDatepicker == 'end'"
                                (click)="openDatePicker('end')">
                                <i class="fa-light fa-calendar"></i>
                                <input placeholder="Fin de venta" class="input-date pointer-in" readonly
                                    [(ngModel)]="endStringDate" [ngModelOptions]="{standalone: true}">
                                <i class="icon-down fa-light fa-chevron-down"></i>
                            </div>
                        </div>
                        <!-- Hora fin venta -->
                        <div class="d-flex align-items-center justify-content-center inputs-hours"
                            [class.error-input]="hourEnd > 23 || hourEnd < 0 || minuteEnd < 0 || minuteEnd > 59 || minuteEnd?.length > 2">
                            <div class="input-hour">
                                <input placeholder="20" type="text" maxlength="2" pattern="[0-9]*"
                                    (blur)="validateHourInput($event, 'hourEnd')"
                                    (keypress)="onlyNumbers($event)"
                                    [(ngModel)]="hourEndStr"
                                    [ngModelOptions]="{standalone: true}" />
                            </div>
                            <span class="points">:</span>
                            <div class="input-hour">
                                <input placeholder="00" type="text" maxlength="2" pattern="[0-9]*"
                                    (blur)="validateMinuteInput($event, 'minuteEnd')"
                                    (keypress)="onlyNumbers($event)"
                                    [(ngModel)]="minuteEndStr"
                                    [ngModelOptions]="{standalone: true}" />
                            </div>
                        </div>
                    </div>
                    <div class="calendar-option" *ngIf="typeDatepicker == 'end'">
                        <app-calendar-event-dates [selectedDate]="endDate" (saveDate)="saveDate($event)"
                            [minDate]="minDate"></app-calendar-event-dates>
                    </div>
                </div>
            </div>
            <!-- Número máximo de entradas -->
            <div class="padding-inputs">
                <div>
                    <p class="title-tickets-max">Entradas máximas por usuario</p>
                    <div class="section-input">
                        <!-- Con entradas nominativas el tope es 1 y no se puede tocar: la
                             regla la impone el evento, no este campo (ver PurchaseLimitService
                             en el backend), así que dejarlo editable haría creer que se puede
                             subir. Se deja `readonly` en vez de deshabilitar el control para
                             que el valor siga viajando en el formulario. -->
                        <div class="input-border select-style input-ticket" [class.input-locked]="isNominative">
                            <input placeholder="Entradas" type="number" min="0"
                                formControlName="max_tickets_per_user"
                                [readonly]="isNominative" />
                            <i class="fa-light fa-ticket icon-primary"></i>
                        </div>
                    </div>
                    <p class="locked-hint" *ngIf="isNominative">
                        Fijado en 1 por las entradas nominativas.
                    </p>
                </div>
            </div>
        </form>
    </div>
</div>
